// THE TOUCH TARGET — the 44pt hit area every control owes a finger
// (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1; Apple HIG: 44 x 44 pt; the brand
// `controlH` sizes token). Three shapes, all spread INSIDE a `'@coarse'` block
// so a mouse never sees them. Two are an `:after` pseudo, so the control's own
// box, padding and layout never change (Rule 66) — only its hit area; the
// third (`touchRow`, below) draws the control itself at the floor.
//
//   touchSlop   — the house tap slop: `inset: tapSlop` grows the control by
//                 6px a side (the brand IconButton / NavbarButton recipe).
//                 Enough for a control of 32px and up: a 36px compact capsule
//                 answers a 48px square.
//   touchFloor  — the 44pt FLOOR for the controls that stay small on a
//                 touch screen: the hit area is the control's own box, never
//                 under `controlH` on either axis, centred on it. A 25px
//                 header button (the 14px iPad-portrait root), the 28px send
//                 button, an 18px swatch: each answers a 44px square. Measured
//                 on dev DFI 2026-10-05 with a touch device simulated — the
//                 send button took 25 x 25 at 834px and the canvas-background
//                 swatch 19 x 19 at 375px.
//
// The pseudo is absolutely positioned, so the control must be a containing
// block: a STATIC control adds `position: 'relative'` beside the spread (a
// control that is already positioned must not — a `'@coarse'` position would
// beat its own). A control that clips (`overflow: hidden`) clips its hit area
// too; it opens up under `'@coarse'` (its own round still clips its fill).
//
//   '@coarse': { position: 'relative', ...touchFloor }
//
// A pseudo reaches past the control's box, so it meets its NEIGHBOUR when the
// two sit closer than the reach: the later one in the tree wins the overlap.
// Measured on dev 19a2e0adb (Finances, 393 / 834, a finger 21px from the
// centre): an icon-only compact capsule (33 or 22px wide) handed its right edge
// to the capsule 9-10px away. Two answers, by where the control sits:
//
//   touchRow    — a control AMONG its neighbours, flush or a hair apart (a
//                 segment, a tab, a list row, a chip in a group that wraps):
//                 it DRAWS `controlH` on both axes under `'@coarse'` and its
//                 own box is its hit area — no pseudo, so it neither takes a
//                 neighbour's edge nor gets cut by the scroll strip it sits in.
//                 '@coarse': { ...touchRow }
//   a pseudo floor on a box of at least `controlHCompact` (36px, the brand
//                 IconButton) — a small control in a toolbar: the floor then
//                 reaches only 4px past the box, so two controls 8px apart
//                 keep their own edges (AppCapsuleBtn's compact rule).
export const touchRow = {
  minHeight: 'controlH',
  minWidth: 'controlH'
}

export const touchSlop = {
  ':after': { content: '""', position: 'absolute', inset: 'tapSlop' }
}

export const touchFloor = {
  ':after': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '100%',
    height: '100%',
    minWidth: 'controlH',
    minHeight: 'controlH',
    transform: 'translate(-50%, -50%)'
  }
}
